module.exports = __webpack_public_path__ + "media/mayasfrom.5798ed8a.mp4";